import http from "@/settings/apiSettings"

class PRO_LoturiFabricatieDataService {
    getByComanda(comandaId: string): Promise<any> {
        return http.clientDocumente.get(`/PRO_LoturiFabricatie/by-comanda/${comandaId}`);
    }
    getAllActive(): Promise<any> {
        return http.clientDocumenteOdata.get(`PRO_LoturiFabricatie?$filter=Anulat ne true`);
    }
}
export default new PRO_LoturiFabricatieDataService();
